import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser } from "../../services/auth.service";
import styles from "./styles.module.css";

const Profile = () => {
  const [redirect, setRedirect] = useState(null);
  const [userReady, setUserReady] = useState(false);
  const [currentUser, setCurrentUser] = useState({ username: "" });

  useEffect(() => {
    const currentUser = getCurrentUser();

    if (!currentUser) {
      setRedirect("/home");
    } else {
      setCurrentUser(currentUser);
      setUserReady(true);
    }
  }, []);

  if (redirect) {
    return <Navigate to={redirect} />;
  }

  return (
    <div className={styles.container}>
      {userReady && (
        <div className={styles.content}>
          <header className={styles.header}>
            <h3>
              <strong>{currentUser.username}</strong> Profile
            </h3>
          </header>
          <div className={styles.infoSection}>
            <p className={styles.infoItem}>
              <strong>Token:</strong>{" "}
              {currentUser.accessToken.substring(0, 20)} ...{" "}
              {currentUser.accessToken.substr(
                currentUser.accessToken.length - 20
              )}
            </p>
            <p className={styles.infoItem}>
              <strong>Id:</strong> {currentUser.id}
            </p>
            <p className={styles.infoItem}>
              <strong>Email:</strong> {currentUser.email}
            </p>
            <div className={styles.rolesSection}>
              <strong>Authorities:</strong>
              <ul className={styles.rolesList}>
                {currentUser.roles &&
                  currentUser.roles.map((role, index) => (
                    <li key={index}>{role}</li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
